import React, { memo } from 'react';
import PropTypes from 'prop-types';

import LandlordTable from '../table';

const AllLandlordTab = memo(
  ({ loading, filters, total, setFilters, landlordNameList, dataSource, setCurrentLandlord }) => {
    return (
      <LandlordTable
        type="all"
        loading={loading}
        filters={filters}
        total={total}
        setFilters={setFilters}
        landlordNameList={landlordNameList}
        dataSource={dataSource}
        setCurrentLandlord={setCurrentLandlord}
      />
    );
  },
);

AllLandlordTab.propTypes = {
  loading: PropTypes.bool.isRequired,
  filters: PropTypes.object.isRequired,
  total: PropTypes.number.isRequired,
  dataSource: PropTypes.array.isRequired,
  setFilters: PropTypes.func.isRequired,
  landlordNameList: PropTypes.array.isRequired,
  setCurrentLandlord: PropTypes.func.isRequired,
};

AllLandlordTab.defaultProps = {
  loading: false,
  filters: {},
  total: 0,
  dataSource: [],
  setFilters: () => {},
  landlordNameList: [],
  setCurrentLandlord: () => {},
};

AllLandlordTab.displayName = 'AllLandlordTab';

export default AllLandlordTab;
